/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import  User  from "../utils/Interface/User"
import "../style/css/tablecomplexe.css";
import { MDBCheckbox, MDBPagination, MDBPaginationItem, MDBPaginationLink } from 'mdb-react-ui-kit';

interface Props {
  users: User[];
  onUserSelect: (user: User) => void;
}

const TableUsers: React.FC<Props> = ({ users, onUserSelect }) => {

  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const totalPages = Math.ceil(users.length / usersPerPage);
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);
  const navigate = useNavigate();

  const handlePageChange = (pageNumber: number) => {
    if (totalPages === 0) {
      setCurrentPage(1);
    } else if (pageNumber < 1) {
      setCurrentPage(1);
    } else if (pageNumber > totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(pageNumber);
    }
  };

  const handleCheckboxChecked = (user: User) => {
    const {user_id, user_name, user_firstname,user_realname, user_email, entity_id, entity_name } = user;
    onUserSelect(user);
    navigate(`/inventaire/utilisateurs/${user.user_id}`);
  };

  return (

    <div>

      <table className="table align-middle mb-0 bg-white">

        <thead className="bg-light">

          <tr className='tablecomplexe__table__categories' >

            <th className="fw-bold mb-1">Nom</th>

            <th className="fw-bold mb-1"> Email</th>

            <th id="entityuser" className="fw-bold mb-1">Entité</th>

          </tr>

        </thead>

        <tbody>

          {currentUsers.map((user, index) => (

            <tr key={index} className='tablecomplexe__table__items' onClick={() => handleCheckboxChecked(user)} >
          
              <td>

                <div className="d-flex-row align-items-center">

                  <p className="fw-bold mb-1">{user.user_name}</p>

                  <p className="text-muted mb-0">{user.user_realname}</p>

                  <p className="text-muted mb-0">{user.user_firstname}</p>

                </div>

              </td>
      
              <td>

                <p>{user.user_email} </p>
                
              </td>

              <td className='edit'>

                <p className="text-muted mb-0">{user.entity_name}</p>

              </td>

            </tr>

          ))}

        </tbody>

      </table>
      
      <nav aria-label='Page navigation'>
        
        <MDBPagination circle className='mb-0'>
          
          <MDBPaginationItem disabled={currentPage === 1}>
            
            <MDBPaginationLink onClick={() => handlePageChange(currentPage - 1)} tabIndex={-1} aria-disabled={currentPage === 1}>
              
              <p className='page'>Page précédente</p>
            
            </MDBPaginationLink>

          </MDBPaginationItem>
    
          <MDBPaginationItem disabled={currentPage === 1}>
            
            <MDBPaginationLink onClick={() => handlePageChange(1)} tabIndex={-1} aria-disabled={currentPage === 1}>
              
              <p className='page' id='number'>1</p>
            
            </MDBPaginationLink>
          
          </MDBPaginationItem>

          {currentPage !== 1 && (
          
          <MDBPaginationItem>
              
            <MDBPaginationLink>
              
              <p className='page' id='number'>{currentPage}</p>
            
            </MDBPaginationLink>
          
          </MDBPaginationItem>
          )}

          <MDBPaginationItem disabled={currentPage === totalPages}>
            
            <MDBPaginationLink onClick={() => handlePageChange(totalPages)}>
              
              <p className='page' id='number'>{totalPages}</p>
            </MDBPaginationLink>
  
          </MDBPaginationItem>

          <MDBPaginationItem disabled={currentPage === totalPages}>
            
          <MDBPaginationLink 
          onClick={() => handlePageChange(currentPage + 1)} 
          aria-disabled={currentPage === totalPages}>
            
            <p className='page'>Page suivante</p>
          
          </MDBPaginationLink>

          </MDBPaginationItem>
        
        </MDBPagination>
      
      </nav>
    
    </div>
  );
};

export default TableUsers;